import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@material-ui/core";
import t from "../../languages/pl";
import CancelAcceptForm from './CancelAcceptForm';

const useStyles = theme => ({
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: theme.spacing(3)
  },
  warning: {
    fontWeight: "bold",
    fontSize: "1.1rem",
    display: "inline=block"
  }

});

const ConfirmationDialog = props => {
  const { classes, id, action, additionalText, infoText, warningText, open, onClose, onSubmit } = props;

  const handleSubmit = () => {
    if (onSubmit)
      onSubmit(id);
    onClose();
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="sm"
      onClose={onClose}
    >
      <DialogTitle>
        {t.confirmation}
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography variant="subtitle1">
          {t.areYouSure}&nbsp;{action}?
          {additionalText ? <Fragment> <br/> <br/> {additionalText}</Fragment> : null}
          {infoText ? <Fragment>
            <br/>
            <br/>
            <Typography>
              {infoText.replace('.', '.\n')}
            </Typography>
          </Fragment> : null}
          {warningText
            ?
            <Fragment>
              <br/>
              <br/>
              <Typography
                align="center"
                color="error"
                className={classes.warning}
              >
                {warningText.replace('.', '.\n')}
              </Typography>
            </Fragment>
            : null}
        </Typography>
      </DialogContent>
      <DialogActions>
        <CancelAcceptForm onCancel={onClose} onSubmit={handleSubmit}/>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(useStyles)(ConfirmationDialog);

ConfirmationDialog.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  action: PropTypes.string,
  additionalText: PropTypes.string,
  infoText: PropTypes.string,
  warningText: PropTypes.string,
  onSubmit: PropTypes.func
};
